var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{attrs:{"contain":"","src":_vm.error ? _vm.noImageUrl : _vm.src},on:{"error":function($event){_vm.error = true}}})}
var staticRenderFns = []

export { render, staticRenderFns }